import { Toast, Dialog } from 'vant'

let activeToastEl = null

/** 超过该长度或含换行时，用弹窗代替底部 toast，避免长文案显示难看 */
const LONG_MESSAGE_THRESHOLD = 22

function shouldUseDialog(text) {
  return text.length > LONG_MESSAGE_THRESHOLD || /\n/.test(text)
}

function clearCustomToastEl() {
  if (!activeToastEl) return
  try {
    activeToastEl.remove()
  } catch (e) {
    console.warn('remove toast el failed', e)
  }
  activeToastEl = null
}

function showDialog(message, options = {}) {
  clearCustomToastEl()
  return Dialog.alert({
    title: options.title || '提示',
    message: String(message || ''),
    confirmButtonText: options.confirmButtonText || '我知道了',
    confirmButtonColor: options.confirmButtonColor || '#FEB013',
    ...options
  })
}

function showShortToast(text, duration = 1800) {
  clearCustomToastEl()

  const el = document.createElement('div')
  activeToastEl = el

  el.style.position = 'fixed'
  el.style.left = '50%'
  el.style.bottom = '14%'
  el.style.transform = 'translateX(-50%)'
  el.style.background = 'rgba(0, 0, 0, 0.78)'
  el.style.color = '#fff'
  el.style.padding = '10px 18px'
  el.style.borderRadius = '999px'
  el.style.zIndex = '9999'
  el.style.fontSize = '14px'
  el.style.lineHeight = '1.4'
  el.style.boxSizing = 'border-box'
  el.style.textAlign = 'center'
  el.style.pointerEvents = 'none'
  el.style.maxWidth = '90vw'
  el.style.width = 'max-content'
  el.style.whiteSpace = 'nowrap'
  el.innerText = text
  document.body.appendChild(el)

  setTimeout(() => {
    el.style.transition = 'opacity 0.3s'
    el.style.opacity = '0'
    setTimeout(() => {
      if (el.parentNode) {
        el.remove()
      }
      if (activeToastEl === el) {
        activeToastEl = null
      }
    }, 300)
  }, duration)
}

export function toast(msg, duration = 1800) {
  if (typeof msg === 'object' && msg !== null) {
    return Toast(msg)
  }

  const text = String(msg || '')
  if (!text) return

  if (shouldUseDialog(text)) {
    return showDialog(text)
  }

  return showShortToast(text, duration)
}

toast.loading = (opts) => Toast.loading(opts)
toast.success = (opts) => Toast.success(opts)
toast.fail = (opts) => Toast.fail(opts)
toast.alert = showDialog
toast.clear = () => {
  Toast.clear()
  clearCustomToastEl()
}
toast.allowMultiple = (val) => Toast.allowMultiple(val)
toast.setDefaultOptions = (opts) => Toast.setDefaultOptions(opts)
toast.resetDefaultOptions = () => Toast.resetDefaultOptions()
